// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-19fc2bb0] {\n  background-color: #b4e2ff;\n  color: #1f2223;\n}\n\n.link[data-v-19fc2bb0] {\n  color: #1f2223;\n}", ""]);
// Exports
module.exports = exports;
